// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__C0yG3","tooltip":"Tooltip_tooltip__Flhnm"};